import script from "./FAQSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQSection.vue?vue&type=script&setup=true&lang=js"

import "./FAQSection.vue?vue&type=style&index=0&id=fd7fb602&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd7fb602"]])

export default __exports__